import { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { SocialProviderUnitDto } from '../../../api-service/clients';
import { useSpuIdFromUrl, SERVICE_PROVIDER_UNIT_PARAM } from './use-spu-id-from-url';

export function useServiceProviderUnitSelection(serviceProviderUnits: SocialProviderUnitDto[] | undefined) {
  const { search } = useLocation();
  const history = useHistory();

  const currentUnitId = useSpuIdFromUrl();

  const currentServiceProviderUnit = useMemo(() => {
    if (!currentUnitId || !serviceProviderUnits) {
      return undefined;
    }
    return serviceProviderUnits.find(unit => unit.id === currentUnitId);
  }, [currentUnitId, serviceProviderUnits]);

  const setCurrentServiceProvider = (unitId: string | undefined) => {
    const newParams = new URLSearchParams(search);
    if (!unitId) {
      newParams.delete(SERVICE_PROVIDER_UNIT_PARAM);
    } else {
      newParams.set(SERVICE_PROVIDER_UNIT_PARAM, unitId);
    }
    history.replace({
      search: newParams.toString(),
    });
  };

  return {
    currentServiceProvider: currentServiceProviderUnit,
    setCurrentServiceProvider,
  };
}
